import Vue from 'vue'
import VueRouter from 'vue-router'
import DictionaryView from "../views/DictionaryView";
import LoginView from "../views/LoginView.vue";
import Settings from "../views/Settings";
import UpdatesView from "../views/UpdatesView.vue";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Dictionary',
    component: DictionaryView
  },
    {
    path: '/login',
    name: 'Login',
    component: LoginView
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings
  },
  {
    path: '/updates',
    name: 'updates',
    component: UpdatesView
  },
]

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes
})

export default router
